import jsonToFormData from '../../../../common/utils/jsonToFormData';
import { formatterMask } from '../../../../common/utils/configFormField';

// Корректирую пришедшие данные (удаляю всё ненужное и убираю лишнюю вложенность)
export const dataAdjustmentResponse = data => {
  let newData = {
    profileId: data.profileId,
    userId: data.userId.userId,
    roleId: data.roleId.roleId,
    roleKey: data.roleId.roleKey,
    role: data.roleId.role,
    companyId: data.companyId && data.companyId.companyId,
    phone: data.userId.phone,
    phoneVerified: data.userId.phoneVerified,
    lastname: data.userId.lastname,
    name: data.userId.name,
    patronymic: data.userId.patronymic,
    birthDate: data.userId.birthDate,
    birthPlace: data.userId.birthPlace,
    photo: data.userId.photo,
    email: data.userId.email,
    sex: data.userId.sexId && String(data.userId.sexId.sexId),
  };

  if (data.userId.foreignLanguages) {
    newData.foreignLanguages = data.userId.foreignLanguages.map(
      item => item.foreignLanguageKey
    );
  }

  if (data.userId.identityDocumentId) {
    newData.identityDocument =
      data.userId.identityDocumentId.identityDocumentId;
  }

  if (data.userId.citizenshipId) {
    newData.citizenship = data.userId.citizenshipId.citizenshipId;
  }

  if (newData.phone !== '') {
    let phone = newData.phone.match(/^(\+7|\+380|\+375)(.*)/);
    if (phone) {
      newData.phoneCode = phone[1];
      newData.phone = phone[2];
      newData.phoneMask =
        (phone[1] ? phone[1] + ' ' : '') +
        (phone[2] ? formatterMask(phone[2], '(###) ###-##-##') : '');
    }
  }

  if (data.userId && data.userId.driverLicenseId) {
    let driverLicense = data.userId.driverLicenseId;
    newData.driverLicense = '';
    if (driverLicense.driverLicenseSeries) {
      newData.driverLicense += driverLicense.driverLicenseSeries;
    }
    if (driverLicense.driverLicenseNum) {
      newData.driverLicense += ' ' + driverLicense.driverLicenseNum;
    }
    if (driverLicense.driverLicenseId) {
      newData.driverLicenseId = driverLicense.driverLicenseId;
    }
    if (driverLicense.endDate) {
      newData.driverLicenseEndDate = driverLicense.endDate;
    }
    if (driverLicense.glassesNeed) {
      newData.glassesNeed = String(driverLicense.glassesNeed);
    }
    if (driverLicense.additionalInformation) {
      newData.additionalInformation = driverLicense.additionalInformation;
    }

    if (driverLicense.photoFront) {
      newData.driverLicensePhotoFront = driverLicense.photoFront;
    }
    if (driverLicense.photoBack) {
      newData.driverLicensePhotoBack = driverLicense.photoBack;
    }

    if (data.userId.driverLicenseId.vehicleCategories) {
      newData['driverLicenseСategories'] = [];
      data.userId.driverLicenseId.vehicleCategories.forEach(item => {
        newData['driverLicenseСategories'].push(item.categoryKey);
        newData['driverLicenseСategoryStartDate_' + item.categoryKey] =
          item.pivot && item.pivot.startDate;
      });
    }
  }

  if (data.userId && data.userId.tachographCards) {
    data.userId.tachographCards.forEach(item => {
      newData['tachographСards_' + item.tachographId.tachographKey] =
        item.tachographCardNum;
      newData['tachographСardsEndDate_' + item.tachographId.tachographKey] =
        item.endDate;
    });
  }

  if (data.profileStatusId) {
    newData.profileStatus = data.profileStatusId.profileStatus;
    newData.profileStatusKey = data.profileStatusId.profileStatusKey;
  }

  if (data.representative) {
    newData.representativeEmail = data.representative.email;
    newData.representativePhone = data.representative.phone;
    newData.representativePhoneCode = data.representative.phoneCode;
    newData.representativeLastname = data.representative.lastname;
    newData.representativeName = data.representative.name;
    newData.representativePatronymic = data.representative.patronymic;
  }

  return newData;
};

// Корректирую данные для отправки
export const dataAdjustmentRequest = data => {
  let newData = {
    profile: {
      role_key: data.roleKey,
    },
    user: {},
  };
  if (data.profileId > 0) {
    newData.profile.profile_id = data.profileId;
  }
  if (data.birthDate && data.birthDate !== '') {
    newData.user.birth_date = data.birthDate.format('YYYY-MM-DD');
  }
  if (data.email) {
    newData.user.email = data.email;
  }
  if (data.lastname) {
    newData.user.lastname = data.lastname;
  }
  if (data.name) {
    newData.user.name = data.name;
  }
  if (data.hasOwnProperty('patronymic')) {
    newData.user.patronymic = data.patronymic;
  }
  if (data.phone && data.phoneCode) {
    newData.user.phone = `${data.phoneCode}${data.phone}`;
  }
  if (data.email) {
    newData.user.email = data.email;
  }
  if (data.sex) {
    newData.user.sex_id = data.sex;
  }
  if (data.birthPlace) {
    newData.user.birth_place = data.birthPlace;
  }

  if (
    data.representativeEmail ||
    data.representativePhone ||
    data.representativeLastname ||
    data.representativeName
  ) {
    newData.representative = {};
    newData.representative.email = data.representativeEmail
      ? data.representativeEmail
      : '';
    if (data.representativePhone) {
      newData.representative.phone = data.representativePhone;
      newData.representative.phone_code = data.representativePhoneCode
        ? data.representativePhoneCode
        : '';
    }
    newData.representative.lastname = data.representativeLastname
      ? data.representativeLastname
      : '';
    newData.representative.name = data.representativeName
      ? data.representativeName
      : '';
    newData.representative.patronymic = data.representativePatronymic
      ? data.representativePatronymic
      : '';
  }

  if (data.foreignLanguages && Array.isArray(data.foreignLanguages)) {
    newData.user.foreign_language_keys = data.foreignLanguages;
  }
  if (data.identityDocument) {
    newData.user.identity_document_id = data.identityDocument;
  }
  if (data.citizenship) {
    newData.user.citizenship_id = data.citizenship;
  }

  let driverLicense = {};
  if (data.driverLicense) {
    let seriesAndNum = data.driverLicense.split(' ');
    if (seriesAndNum) {
      driverLicense.driver_license_series = seriesAndNum[0]
        ? seriesAndNum[0]
        : '';
      driverLicense.driver_license_num = seriesAndNum[1] ? seriesAndNum[1] : '';
    }
  }
  if (data.driverLicenseEndDate && data.driverLicenseEndDate !== '') {
    driverLicense.end_date = data.driverLicenseEndDate.format('YYYY-MM-DD');
  }
  if (data.glassesNeed) {
    driverLicense.glasses_need = data.glassesNeed;
  }
  if (data.additionalInformation) {
    driverLicense.additional_information = data.additionalInformation;
  }
  if (data.driverLicenseСategories) {
    driverLicense.vehicle_categories = data.driverLicenseСategories.map(
      item => {
        let obj = { category_key: item };
        let startDate = data[`driverLicenseСategoryStartDate_${item}`];
        if (startDate) {
          obj.start_date = startDate.format('YYYY-MM-DD');
        }
        return obj;
      }
    );
  }
  if (Object.keys(driverLicense).length > 0) {
    newData.user.driver_license = driverLicense;
  }

  let tachographСards = ['skzi', 'estr']
    .map(key => {
      if (data[`tachographСards_${key}`]) {
        let obj = {
          tachograph_key: key,
          tachograph_card_num: data[`tachographСards_${key}`],
        };
        let endDate = data[`tachographСardsEndDate_${key}`];
        if (endDate) {
          obj.end_date = endDate.format('YYYY-MM-DD');
        }
        return obj;
      }
      return false;
    })
    .filter(item => item);
  if (tachographСards.length > 0) {
    newData.user.tachograph_cards = tachographСards;
  }

  if (data.profileId === 0) {
    const formData = jsonToFormData(newData);
    if (data.photo) {
      formData.append('user[photo]', data.photo);
    }
    if (data.driverLicensePhotoFront) {
      formData.append(
        'user[driver_license][photo_front]',
        data.driverLicensePhotoFront
      );
    }
    if (data.driverLicensePhotoBack) {
      formData.append(
        'user[driver_license][photo_back]',
        data.driverLicensePhotoBack
      );
    }
    return formData;
  }
  return newData;
};

export const dataAdjustmentErrorResponse = data => {
  let newData = { ...data };
  if (newData.key) {
    switch (newData.key) {
      case 'profile.role_key':
        newData.key = 'roleKey';
        break;
      case 'user.phone':
        newData.key = 'phone';
        break;
      case 'user.lastname':
        newData.key = 'lastname';
        break;
      case 'user.name':
        newData.key = 'name';
        break;
      case 'user.birth_date':
        newData.key = 'birthDate';
        break;
      case 'user.photo':
        newData.key = 'photo';
        break;
      case 'user.email':
        newData.key = 'email';
        break;
      case 'representative.email':
        newData.key = 'representativeEmail';
        break;
      case 'representative.phone':
      case 'representative.phone_code':
        newData.key = 'representativePhoneCode';
        break;
      case 'representative.lastname':
        newData.key = 'representativeLastname';
        break;
      case 'representative.name':
        newData.key = 'representativeName';
        break;
      default:
    }
  }
  return newData;
};
